import React, { Component } from 'react';
import{ Button } from 'react-bootstrap';
import LoadingOverlay from '../../components/LoadingOverlay';
import FieldGroup from '../../components/FieldGroup';
import API from '../../services/API';

import './index.css'

class Login extends Component {
    constructor() {
        super();

        this.state = {
            isError: false,
            isLoading: false,
            user: '',
            password: ''
        }

        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleOnFocus() {
        this.setState({
            isError: false
        })
    }

    handleFieldChange(event) {
        const {target} = event;
        const {value,name} = target;

        this.setState({
            [name]: value
        });
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { user, password } = this.state;

        this.setState({
            isLoading: true
        })

        const isLogged = await API.Login.login(user, password);

        if (isLogged) {
            const url = new URL(document.location.href);
            const back_to = url.searchParams.get('back_to');

            return window.location.href = back_to ? window.atob(back_to) : '/';
        } else {
            this.setState({ isError: true, isLoading: false })
        }
    }

    getForm() {
        return (
            <form className="login" onSubmit={this.handleSubmit}>
                <FieldGroup
                    name="user"
                    label="User:"
                    onChange={this.handleFieldChange}
                    onFocus={this.handleOnFocus}
                    value={this.state.user}
                    required
                />
                <FieldGroup
                    name="password"
                    type="password"
                    label="Pasword:"
                    onChange={this.handleFieldChange}
                    onFocus={this.handleOnFocus}
                    value={this.state.password}
                    required
                />
                {this.state.isError ? <p className="alert alert-danger">Wrong user or name</p> : ''}
                <Button bsStyle="success" type="submit">Log in</Button>
            </form>
        );
    }

    render() {
        return this.state.isLoading ? <LoadingOverlay/> : this.getForm();
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/scenes/Login/index.js